import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bestcabserviceinhyderabad() {



  const cardData =
  {
    keyword: 'Best Cab Services in Hyderabad',
    heading: 'Aaryan Travels: Best Cab Services in Hyderabad',
    headingDescription: ' Aaryan Travels is recognized among the Best Cab Services in Hyderabad, offering safe, punctual, and affordable travel solutions for both residents and business travelers. Whether you need a daily commute, airport transfer from Rajiv Gandhi International Airport, corporate ride to HITEC City, or weekend trip to nearby destinations like Ramoji Film City or Srisailam, our fleet of sedans, SUVs, and luxury vehicles ensures a smooth and comfortable experience. With professional chauffeurs, transparent pricing, and 24/7 service availability, Aaryan Travels makes every ride in Hyderabad convenient and stress-free. From Gachibowli to Kukatpally, Banjara Hills to Secunderabad, we provide dependable cab services across the city.',

    top: 'Top Places to Visit in Hyderabad with Aaryan Travels',

"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar, built in 1591 by Sultan Muhammad Quli Qutb Shah, is Hyderabad’s most renowned landmark. With four towering minarets and intricate Indo-Islamic architecture, it stands majestically at the heart of the old city. Surrounding bazaars like Laad Bazaar buzz with bangles, perfumes, and street food. Illuminated beautifully at night, it attracts tourists and photographers alike. Charminar is Hyderabad’s iconic symbol of heritage and culture."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a massive granite fortress known for its strategic architecture and acoustic marvels. Once the capital of the Qutb Shahi dynasty, it was famed for producing legendary diamonds including Kohinoor. Visitors enjoy exploring its royal chambers, cannons, and panoramic viewpoints. The evening sound and light show narrates its glorious history. Golconda Fort is Hyderabad’s monumental pride of strength and legacy."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City is the world’s largest integrated film studio complex, spread across 2000 acres. It offers guided tours through movie sets, theme parks, adventure zones, and live shows. Families enjoy thrilling attractions like stunt shows, toy trains, and fantasy streets. It feels like stepping into multiple cinematic worlds. Ramoji Film City is Hyderabad’s grand destination of entertainment and imagination."
  },
  {
    "title": "Hussain Sagar Lake & Buddha Statue",
    "description": "Hussain Sagar Lake, shaped like a heart, connects Hyderabad and Secunderabad. At its center stands a majestic 58-feet tall monolithic Buddha statue on a rock island. Boat rides during sunset offer enchanting views of the illuminated skyline. The surrounding Necklace Road is perfect for evening strolls and street snacks. Hussain Sagar is Hyderabad’s scenic symbol of peace and unity."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum houses one of the world’s largest personal art collections, curated by Mir Yousuf Ali Khan (Salar Jung III). It features rare sculptures, paintings, clocks, and antiques from across Europe, Asia, and India. Highlights include the Veiled Rebecca statue and the famous musical clock. Each gallery tells a tale of world history. Salar Jung Museum is Hyderabad’s artistic treasure chest."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir is a serene white marble temple dedicated to Lord Venkateswara, perched atop Naubat Pahad hill. The temple blends Rajasthani and Dravidian architecture, offering sweeping views of the city and lake. Illuminated at night, it looks heavenly against the skyline. Visitors feel calm and spiritually uplifted. Birla Mandir is Hyderabad’s peaceful beacon of devotion."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace was the official residence of the Nizams, showcasing Persian-style architecture with opulent chandeliers and marble courtyards. The Khilwat Mubarak hall is the grandest attraction. Vintage cars, royal furniture, and artifacts keep history alive. Cultural events and photography shoots often take place here. Chowmahalla Palace is Hyderabad’s royal testament to luxury and legacy."
  },
  {
    "title": "Mecca Masjid",
    "description": "Mecca Masjid is one of India’s oldest and largest mosques, built using soil brought from Mecca. Its high arches, sprawling prayer halls, and reflective ponds create a serene atmosphere. Thousands gather here every Friday for prayers. Pigeons fluttering in the courtyard add charm. Mecca Masjid is Hyderabad’s timeless sanctuary of faith."
  },
  {
    "title": "Nehru Zoological Park",
    "description": "Nehru Zoological Park is one of the largest zoos in India, spreading over 380 acres with diverse wildlife including tigers, lions, elephants, and birds. Safari rides, toy trains, and aquariums make it a family favorite. The lush greenery offers a refreshing natural escape. It also promotes wildlife conservation awareness. Nehru Zoo is Hyderabad’s lively wild getaway."
  },
  {
    "title": "Snow World",
    "description": "Snow World is India’s first and largest snow-themed amusement park where visitors enjoy sub-zero fun with artificial snowfall, ice slides, and igloos. Jackets and boots are provided to enhance the experience. Families and children love snowball fights and dancing under flurries. It feels like a mini Switzerland in the heart of the city. Snow World is Hyderabad’s coolest thrill zone."
  }
],


"services": [
  {
    "name": "Best Cab Services in Hyderabad",
    "description": "Discover the best cab services in Hyderabad, where comfort, safety, and punctuality are our top priorities. Whether you're commuting within the city, heading to the airport, or travelling outstation, you can expect well-maintained vehicles, courteous drivers, transparent pricing, and 24/7 support. From stylish sedans to roomy SUVs, we offer a cab type for every need and budget, ensuring that your journey is smooth, reliable, and enjoyable every time."
  },
  {
    "name": "Top Taxi Companies Hyderabad",
    "description": "Connect with the top taxi companies in Hyderabad known for their outstanding service, fleet of diverse vehicle types, professionalism, and strong customer reviews. These companies provide a full suite of services—local rides, airport transfers, corporate bookings, and airport drop/pickups—and ensure that safety, driver training, and timely arrival are never compromised."
  },
  {
    "name": "Affordable Cab Hyderabad",
    "description": "Affordable Cab Hyderabad delivers wallet-friendly travel without sacrificing quality. Designed for daily routes, college students, frequent travelers, and budget-conscious commuters, this service ensures clean cab interiors, driver verification, and no hidden charges. Transparent fare estimates and flexible payment options make it easy to plan your trips affordably."
  },
  {
    "name": "Hyderabad Taxi Booking",
    "description": "With Hyderabad Taxi Booking, you can reserve your ride for any time you need—now or in advance—via app or website. Choose from hatchbacks, sedans, SUVs, or premium cars; specify pickup/drop-off points; and get a fare estimate before confirming. Ideal for both locals and visitors who value convenience, reliability, and clear communication throughout their journey."
  },
  {
    "name": "Trusted Taxi Hyderabad",
    "description": "Trusted Taxi Hyderabad provides dependable service you can count on. Every vehicle is regularly inspected, every driver is background-checked, and rides are GPS-tracked so you feel safe and in control. Whether it's late at night or early morning, you can rely on this service for punctual, courteous and secure travel."
  },
  {
    "name": "Premium Cab Services Hyderabad",
    "description": "Experience elevated travel with Premium Cab Services Hyderabad—luxury interior vehicles, high-end comfort, and chauffeur-level service. Suited for business travelers, special occasions, or those who prefer extra comfort. These cabs often include amenities like leather seats, infotainment, and professional chauffeurs trained in etiquette and route optimization."
  },
  {
    "name": "Local Cab Hyderabad",
    "description": "Local Cab Hyderabad is perfect for short-distance rides within the city—shopping, work, or running daily errands. With quick dispatch, familiar local drivers who understand the traffic, and shorter wait times, this service aims to make city travel stress-free. Vehicles are clean and well-maintained, and you can typically select your preferred cab type."
  },
  {
    "name": "Outstation Cab Hyderabad",
    "description": "Planning a trip outside the city? Outstation Cab Hyderabad offers safe, comfortable, and cost-transparent travel to nearby cities and destinations. Whether it’s a one-way drop, round trip, or multi-day journey, this service provides suited vehicles, rest stops, and experienced drivers familiar with highway routes. Ideal for weekend getaways, family trips, or intercity business travel."
  },
  {
    "name": "Sedan Taxi Hyderabad",
    "description": "For riders who prefer style, comfort, and a smooth ride, Sedan Taxi Hyderabad comes with sedans that are ideal for business meetings, airport transfers, or city travel. These cabs are air-conditioned, spacious, and driven by courteous drivers, giving you a refined travel experience without breaking your budget."
  },
  {
    "name": "SUV Hire Hyderabad",
    "description": "SUV Hire Hyderabad offers roomy and powerful vehicles suited for family trips, larger groups, or for travelers with lots of luggage. Ideal for outstation journeys, airport rides, or areas where extra space is appreciated. These SUVs are well-maintained and come with professional drivers to ensure comfort throughout your travel."
  },
  {
    "name": "Reliable Cab Hyderabad",
    "description": "Reliability is core to Reliable Cab Hyderabad: consistent on-time pickups, clear fare estimations, driver professionalism, and clean vehicles. Useful for both frequent daily rides and occasional journeys, this service is designed to minimize uncertainties and deliver dependable travel every time."
  },
  {
    "name": "Online Cab Booking Hyderabad",
    "description": "Book your cab online in Hyderabad anytime via web or mobile app. This service provides instant fare estimates, ride tracking, multiple payment methods, and easier cancellations if plans change. Perfect for modern travelers who value convenience and peace of mind knowing you can manage your ride from your phone."
  },
  {
    "name": "24x7 Taxi Hyderabad",
    "description": "Whenever you need a ride—day or night—24x7 Taxi Hyderabad is available. Whether it's early morning airport runs, late-night outings, or shift-work travel, this service promises round-the-clock availability with quickly dispatched vehicles, well-trained drivers, and safety features like GPS tracking and emergency contact support."
  },
  {
    "name": "Fast Cab Hyderabad",
    "description": "Need to reach somewhere quickly? Fast Cab Hyderabad offers swift pickups and efficient routing to reduce wait and travel time. Whether it's for urgent meetings, tight schedules, or last-minute plans, this service prioritizes speed without compromising safety, vehicle condition, or driver professionalism."
  },
  {
    "name": "Corporate Cab Hyderabad",
    "description": "Corporate Cab Hyderabad specializes in business travel—employee commute, client meetings, airport transfers, and regular corporate routes. With fleet options like premium sedans and SUVs, monthly plans, and dedicated customer support, this service is tailored for organizations seeking professionalism, punctuality, and a higher level of service consistency and employee experience."
  }
],
"tableData": [
  ["Best Cab Services in Hyderabad", "Top Taxi Companies Hyderabad"],
  ["Affordable Cab Hyderabad", "Hyderabad Taxi Booking"],
  ["Trusted Taxi Hyderabad", "Premium Cab Services Hyderabad"],
  ["Local Cab Hyderabad", "Outstation Cab Hyderabad"],
  ["Sedan Taxi Hyderabad", "SUV Hire Hyderabad"],
  ["Reliable Cab Hyderabad", "Online Cab Booking Hyderabad"],
  ["24x7 Taxi Hyderabad", "Fast Cab Hyderabad"],
  ["Corporate Cab Hyderabad", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Trusted and Best-Rated Cab Services in Hyderabad",
    "WhyChoosedescription": "Aaryan Travels is known for providing reliable, safe, and timely cab services across Hyderabad for all travel needs."
  },
  {
    "WhyChooseheading": "Fast and Convenient Pickups Across Hyderabad",
    "WhyChoosedescription": "With cabs available throughout the city, we ensure quick pickups and smooth travel experiences."
  },
  {
    "WhyChooseheading": "Clean, Comfortable, and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cars maintained for your comfort, safety, and peace of mind."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are trained, courteous, and well-acquainted with Hyderabad’s routes and traffic conditions."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy competitive, all-inclusive fares with clear billing and no surprises at the end of your ride."
  },
  {
    "WhyChooseheading": "24/7 Customer Support and Booking Assistance",
    "WhyChoosedescription": "Our round-the-clock support team ensures your bookings and travel queries are handled without delay."
  },
  {
    "WhyChooseheading": "Flexible Cab Booking Options",
    "WhyChoosedescription": "Choose from local rides, airport transfers, outstation trips, or hourly rentals based on your requirement."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Every Need",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers based on your group size and luggage."
  }
]



























  }

const faqData = [
  {
    question: 'Is Aaryan Travels considered one of the best cab services in Hyderabad?',
    answer: 'Yes, Aaryan Travels is recognized for offering reliable, comfortable, and professional cab services across Hyderabad for all types of travel needs.',
  },
  {
    question: 'What makes Aaryan Travels a top cab service provider in Hyderabad?',
    answer: 'We focus on punctuality, well-maintained vehicles, experienced drivers, and exceptional customer support to ensure a superior travel experience.',
  },
  {
    question: 'What types of cabs are available with Aaryan Travels in Hyderabad?',
    answer: 'Our fleet includes hatchbacks, sedans, SUVs, and premium cars, ideal for local rides, airport transfers, and outstation trips.',
  },
  {
    question: 'Can I book Aaryan Travels cabs for both local and outstation travel in Hyderabad?',
    answer: 'Yes, we provide seamless taxi services for local city travel as well as outstation destinations from Hyderabad.',
  },
  {
    question: 'Is Aaryan Travels available for airport cab services in Hyderabad?',
    answer: 'Absolutely. We offer timely and dependable airport pickup and drop services to and from Rajiv Gandhi International Airport.',
  },
  {
    question: 'How can I book a cab in Hyderabad with Aaryan Travels?',
    answer: 'You can easily book your cab through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'Are Aaryan Travels’ drivers professional and familiar with Hyderabad routes?',
    answer: 'Yes, all our drivers are trained, licensed, and well-versed with Hyderabad’s routes to ensure safe and efficient travel.',
  },
  {
    question: 'Is 24x7 cab service available in Hyderabad with Aaryan Travels?',
    answer: 'Yes, we operate round-the-clock to cater to your travel requirements at any time of the day or night.',
  },
  {
    question: 'What safety protocols are followed for cab services in Hyderabad?',
    answer: 'Our vehicles are sanitized regularly, and our drivers adhere to strict safety and hygiene protocols.',
  },
  {
    question: 'What payment options does Aaryan Travels accept for cab services in Hyderabad?',
    answer: 'We accept cash, credit/debit cards, UPI, and major digital wallets for your convenience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ravi Narayan',
    feedback: 'Aaryan Travels is hands down the best cab service in Hyderabad. Always on time and very professional!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Swati Iyer',
    feedback: 'Comfortable rides and courteous drivers. Aaryan Travels truly offers the best cab experience in Hyderabad.',
    rating: 5,
  },
];



























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Cab Services in Hyderabad",
  "image": "https://aaryantravels.com/assets/images/best-cab-hyderabad.jpg", // replace with actual image URL
  "description": "Top-rated, affordable, and reliable cab services in Hyderabad by Aaryan Travels. Offering local, outstation, sedan, SUV, and corporate cab bookings 24x7 with trusted drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",  // example rating, update if needed
    "ratingCount": "3200", // example rating count, update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1100",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/best-cab-services-hyderabad"
  }
};





  return (
    <div>
<Helmet>
  <title>Best Cab Services in Hyderabad | Affordable & Reliable Cabs | Aaryan Travels</title>
  <meta
    name="description"
    content="Top-rated, affordable, and reliable cab services in Hyderabad by Aaryan Travels. Offering local, outstation, sedan, SUV, and corporate cab bookings 24x7 with trusted drivers."
  />
  <meta
    name="keywords"
    content="Best Cab Services in Hyderabad, Top Taxi Companies Hyderabad, Affordable Cab Hyderabad, Hyderabad Taxi Booking, Trusted Taxi Hyderabad, Premium Cab Services Hyderabad, Local Cab Hyderabad, Outstation Cab Hyderabad, Sedan Taxi Hyderabad, SUV Hire Hyderabad, Reliable Cab Hyderabad, Online Cab Booking Hyderabad, 24x7 Taxi Hyderabad, Fast Cab Hyderabad, Corporate Cab Hyderabad"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/26.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bestcabserviceinhyderabad;